<template>
  <create-dialog
    width="70%"
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @validate="validateForm"
    ref="createDialog"
  >
    <template slot="form">
      <div class="row">
        <div :class="`col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6`">
          <fg-input
            type="text"
            :label="`${$t('common_words.code')}: `"
            v-model="model.code"
            placeholder="..."
          ></fg-input>
        </div>
        <div :class="`col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6`">
          <fg-input
            type="text"
            :label="`${$t('common_words.name')}: *`"
            v-model="model.name"
            name="common_words.name"
            v-validate="modelValidations.name"
            :error="getError('common_words.name', true)"
            placeholder="..."
          >
          </fg-input>
        </div>
        <div :class="`col-12`">
          <select-businesses-component
            ref="selectBusiness"
            :showLoading="true"
            :requiered="true"
            :initialData="businessesInitial"
            @onChange="updateSelectedBusinesses"
            @showHideLoading="showHideLoading"
          />
        </div>
        <div :class="`col-12`">
          <div class="form-group has-label">
            <label>{{ $t('inventory.supplying_belongs_to_farm') }}</label>
            <el-switch
              @change="disableFarmAndLots()"
              v-model="supplyingBelongsToFarm"
              :active-text="`${$t('common_words.yes')}`"
              :inactive-text="`${$t('common_words.no')}`"
              style="margin-left: 1rem"
              active-color="#6BA652"
              inactive-color="#ff4949"
            >
            </el-switch>
          </div>
        </div>
        <div :class="`col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4`">
          <div class="form-group has-label">
            <label>{{ $t('common_words.farm') }}: </label>
            <br />
            <el-select
              @change="getLotsByFarm()"
              clearable
              :disabled="disableFarms"
              filterable
              class="select-primary custom-width-select mb-3 shadow-sm required-farm"
              v-model="model.farm_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                class="select-primary"
                v-for="option in farms"
                :label="option.name"
                :value="option.id"
                :key="option.id + option.name"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div :class="`col-12 col-sm-6 col-md-6 col-lg-5 col-xl-5`">
          <div class="form-group has-label">
            <label>{{ $t('inventory.supplyings') }}: </label>
            <br />
            <el-select
              @change="
                selectAllFromSelect('model.supplyings_id', supplyingsByFarm)
              "
              collapse-tags
              clearable
              filterable
              multiple
              :disabled="disableSupplyings"
              class="select-primary custom-width-select shadow-sm required-supplyings"
              size="large"
              v-model="model.supplyings_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in supplyingsByFarm"
                class="select-primary selected-all"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div :class="`col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3`">
          <div class="form-group has-label">
            <label>{{ $t('common_words.allotments') }}: </label>
            <br />
            <el-select
              @change="selectAllFromSelect('model.lots_id', lotsByFarm)"
              collapse-tags
              clearable
              filterable
              :disabled="disableLots"
              multiple
              class="select-primary custom-width-select shadow-sm required-lots"
              size="large"
              v-model="model.lots_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in lotsByFarm"
                class="select-primary selected-all"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </template>
  </create-dialog>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';
export default {
  name: 'edit-or-create',
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    '$i18n.locale': ['getSelectAll'],
    syncDialog(newValue) {
      if (newValue.create) {
        this.openModal('create', newValue.disabledField);
      } else {
        this.closeModal('create', newValue.disabledField);
      }
    },
  },
  mixins: [
    MixinDialog,
    MixinForm,
    MixinPermissions,
    MixinLoading,
    MixinValidations,
  ],
  data() {
    return {
      disabledField: false,
      businessesInitial: [],
      farms: [],
      supplyings: [],
      lots: [],
      supplyingsByFarm: [],
      lotsByFarm: [],
      disableLots: true,
      disableSupplyings: true,
      disableFarms: false,
      supplyingBelongsToFarm: true,
      model: {
        code: null,
        name: null,
        farm_id: null,
        businesses_id: [],
        businesses_names: [],
        lots_id: [],
        lots_name: [],
        supplyings_id: [],
        supplyings_name: [],
      },
      modelValidations: {
        name: { required: true },
      },
    };
  },
  methods: {
    validateForm() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.businesses_id))
            return this.validationInputsRequired('bus-rels');
          if (this.supplyingBelongsToFarm) {
            if (!isset(this.model.farm_id))
              return this.validationInputsRequired('farm');
          }
          if (!this.supplyingBelongsToFarm) {
            if (!isset(this.model.supplyings_id))
              return this.validationInputsRequired('supplyings');
          } else {
            this.$emit('addEdit', this.model);
          }
        }
      });
    },
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },
    disableFarmAndLots() {
      if (!this.supplyingBelongsToFarm) {
        this.disableFarms = true;
        this.disableLots = true;
      } else {
        this.disableFarms = false;
        this.disableSupplyings = true;
      }
      this.model.farm_id = null;
      this.model.lots_id = [];
      this.model.supplyings_id = [];
      this.getLotsByFarm();
    },
    listLots() {
      if (this.model.farm_id) {
        this.lotsByFarm = this.farms
          .filter((farm) => farm.id == this.model.farm_id)
          .flatMap((farm) => farm.lots);
        this.lotsByFarm = this.concatAll(this.lotsByFarm);
      } else {
        this.lotsByFarm = [];
      }
    },
    listSupplyings() {
      if (!this.supplyingBelongsToFarm) {
        this.disableSupplyings = false;
        this.supplyingsByFarm = this.supplyings.filter(
          (supplying) => supplying.farms.length === 0
        );
        this.supplyingsByFarm = this.concatAll(this.supplyingsByFarm);
      } else if (this.model.farm_id) {
        this.supplyingsByFarm = this.supplyings.filter((supplying) =>
          supplying.farms.some((farm) => farm.id === this.model.farm_id)
        );
        this.supplyingsByFarm = this.concatAll(this.supplyingsByFarm);
      } else {
        this.supplyingsByFarm = [];
      }
    },
    getLotsByFarm() {
      if (isset(this.model.farm_id) && this.supplyingBelongsToFarm) {
        this.disableLots = false;
        this.disableSupplyings = false;
        this.listLots();
        this.listSupplyings();
      }
      if (!isset(this.model.farm_id)) {
        this.model.farm_id = null;
        this.model.lots_id = [];
        this.model.supplyings_id = [];
        this.supplyingsByFarm = [];
        this.lotsByFarm = [];
      }
      if (!this.supplyingBelongsToFarm) {
        this.disableSupplyings = false;
        this.listSupplyings();
      }
    },
    checkDataInUpdateRecord() {
      if (isset(this.model.farm_id)) {
        this.supplyingBelongsToFarm = true;
        this.disableLots = false;
        this.disableSupplyings = false;
      } else {
        this.supplyingBelongsToFarm = false;
        this.disableFarms = true;
      }
      this.listSupplyings();
      this.listLots();
    },
  },
  mounted() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([
        Axios.getMasters('farms/farms/only'),
        Axios.getMasters('inventory/supplying'),
      ])
        .then(([responseFarms, responseSupplying]) => {
          this.farms = responseFarms.data.data;
          this.supplyings = responseSupplying.data.data;
          setTimeout(() => {
            this.showHideLoading();
          }, 1000);
        })
        .catch((error) => this.showMessageErrors(error));
    }
  },
  updated() {
    if (sessionStorage.getItem('editForm') && this.isUpdate()) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      const { id, code, name, farm_id, supplyings, lots } = editForm;
      this.supplyingsByFarm = [];
      this.lotsByFarm = [];
      this.model = {
        ...this.model,
        id,
        code,
        name,
        farm_id,
        isEdit: true,
        supplyings_id: supplyings.map((supplying) => supplying.id),
        lots_id: lots.map((lot) => lot.id),
      };
      this.checkDataInUpdateRecord();
      const { business, businesses } = editForm;
      this.$set(this, 'businessesInitial', businesses ? businesses : business);
      sessionStorage.removeItem('editForm');
    }
  },
};
</script>
